import { render, staticRenderFns } from "./Vitara.vue?vue&type=template&id=7cb00502&"
import script from "./Vitara.vue?vue&type=script&lang=ts&"
export * from "./Vitara.vue?vue&type=script&lang=ts&"
import style0 from "./Vitara.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports